import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ResortDetail, ResortInventory } from '../../models/presentation.model';
import { ResortComponent } from '../../shared/resort.component';
import { UpdateClientService } from '../../services/update-client.service';
import { ResortDetailsPageEvents } from '../../instrumentation/resort-custom-events';
import { UserActivityLogger, UserActivityLoggerOptions } from '../../instrumentation/user-activity-logger.service';
//import Useractivityloggerservice = require("../../instrumentation/user-activity-logger.service");
//import UserActivityLoggerOptions = Useractivityloggerservice.UserActivityLoggerOptions;

@Component({
    selector: 'availability-card',
    templateUrl: './availability-card.component.html',
    styleUrls: ['./availability-card.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AvailabilityCardComponent extends ResortComponent
{
    @Input()
    public resort: ResortDetail;
    @Input()
    public inventory: ResortInventory;
    
    constructor(private updateClientService: UpdateClientService){
        super();
    }

    public get hasDiscount(): boolean{
        return this.inventory && this.inventory.hasDiscount;
    }
    
    public get hasEarnReward(): boolean{
        return this.inventory.reward > 0;
    }

    public get memberRate(): number{
        return this.inventory.getMemberRate(this.configuration.ShowPricePerDay);
    }

    public book(): void
    {
        UserActivityLogger.logEvent(ResortDetailsPageEvents.CarouselBookButtonClicked, { resortId: this.resort.id, inventoryId: this.inventory.id, intervalId: this.inventory.intervalId }, UserActivityLoggerOptions.AppInsightsOnly);
        this.updateClientService.EnsureLatestVersion( () => {
            this.application.checkOut(this.resort, this.inventory);
        });
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-detail/resort-availability/availability-card.component.ts